document.addEventListener("DOMContentLoaded", function () {
  const checkElement = setInterval(() => {
    const container = document.querySelector(".content-align-bottom");
    const allLinks = document.querySelectorAll(".full-unstyled-link");
    if (container) {
      const applyDynamicWidth = () => {
        const computedStyle = getComputedStyle(container);
        const containerWidth = parseFloat(computedStyle.width);
        // Calculate 95% of the container's width
        const newWidth = containerWidth * 0.95;
        allLinks.forEach((link) => {
          // Apply the new width to the link element
          link.style.width = newWidth + "px";
        });
      };

      applyDynamicWidth();

      window.addEventListener("resize", applyDynamicWidth);
      window.addEventListener("zoom", applyDynamicWidth); // Note: 'zoom' event is not supported in all browsers

      // Alternatively, handle zoom using a resize observer
      let previousDevicePixelRatio = window.devicePixelRatio;
      setInterval(() => {
        if (previousDevicePixelRatio !== window.devicePixelRatio) {
          previousDevicePixelRatio = window.devicePixelRatio;
          applyDynamicWidth();
        }
      }, 100);
      clearInterval(checkElement); // Stop checking once the element is found
    }
  }, 100);

  // Get the computed width of the container
});
